import React from 'react';
import { AttachMediaModal } from '../../../../components/AttachMediaModal';
import { ElementWrapper } from '../../../../components/ElementWrapper';
import { IElement } from '../../../../models/Element';
import { HomeShowcaseBoxHighlightLeftContent } from './HomeShowcaseBoxHighlightLeftContent';
import { HomeShowcaseBoxHighlightLeft } from './HomeShowcaseBoxHighlightLeft';
import { HomeShowcaseBoxHighlightLeftFigure } from './HomeShowcaseBoxHighlightLeftFigure';

interface HomeImageRightDescriptionProps {
  index: number;
  data: HomeShowcaseBoxHighlightLeft;
  updateData: (element: IElement, index: number) => void;
}

export const HomeShowcaseBoxHighlightLeftFC: React.FC<
  HomeImageRightDescriptionProps
> = ({ index, data, updateData }) => {
  const update = (fieldsToUpdate: Partial<HomeShowcaseBoxHighlightLeft>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };

  return (
    <>
      <AttachMediaModal
        modalId={`${data.name}-${data.id}`}
        updateCallback={(image, image_alt) =>
          update({ image_preview: image, image_preview_alt: image_alt })
        }
      />

      <ElementWrapper elementIndex={index}>
        <div className="home-showcase-box-highlight-left">
          <div className="position-relative align-items-center showcase">
            <HomeShowcaseBoxHighlightLeftContent data={data} update={update} />
            <HomeShowcaseBoxHighlightLeftFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
